import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"remove\">\n<g>\n\t<path d=\"M14.583 9.167H5.417A.417.417 0 0 0 5 9.583v.834c0 .23.187.416.417.416h9.166c.23 0 .417-.186.417-.416v-.834a.417.417 0 0 0-.417-.416zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16z\" fill-rule=\"evenodd\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol